module.exports = __webpack_public_path__ + "static/kv-2x-8df0d5df53e8bebceb49474770614deb.png";